import { gql } from "@apollo/client";
import { Contact as contact } from "../fragments";
import SEARCH_SYNOPSIS_TERMS from "../fragments/SearchSynopsisTerms";

const FETCH_CONTACT = props => gql`
  query FetchContact($id: Int) {
    contact(id: $id) {
      ${contact(props)}
    }
  }
`;

const FETCH_CONTACTS_V2 = props => gql`
  query FetchContactsV2($input: AdvContactFilterInput!) {
    contactsV2(input: $input) {
      count
      edges {
        ${contact(props)}
      }
      sqlQuery
    }
  }
`;

const CONTACT_LIST_FIELDS = `
  count
  edges {
    id
    company
    country {
      id
      name
    }
    county
    defaultAddress {
      country {
        name
      }
      county
    }
    email
    img
    name
    salesUser {
      id
      name
    }
    title
    totalSpend
    type {
      id
      name
    }
  }
  sqlQuery
`;

const FETCH_CONTACTS_LIST = props => gql`
  query FetchContactsList($input: AdvContactFilterInput!) {
    contactsV2(input: $input) {
      ${CONTACT_LIST_FIELDS}
    }
  }
`;

// The results page also shows the search as removable tags.
const FETCH_CONTACTS_SEARCH_RESULTS = gql`
  query FetchContactsSearchResults($input: AdvContactFilterInput!) {
    contactsV2(input: $input) {
      ${CONTACT_LIST_FIELDS}
      ${SEARCH_SYNOPSIS_TERMS}
    }
  }
`;

const FETCH_CONTACT_LOCATIONS = gql`
  query FetchContactLocations {
    contactLocations
  }
`;

const FETCH_CONTACT_PRIMARY_ADDRESS = gql`
  query FetchContactPrimaryAddress($id: Int!) {
    contact(id: $id) {
      address
      address2
      address3
      country {
        id
        continent
        digraph
        name
      }
      county
      town
      postcode
    }
  }
`;

export {
  FETCH_CONTACT,
  FETCH_CONTACTS_V2,
  FETCH_CONTACTS_LIST,
  FETCH_CONTACTS_SEARCH_RESULTS,
  FETCH_CONTACT_LOCATIONS,
  FETCH_CONTACT_PRIMARY_ADDRESS,
};
